(function () {
	if ((location.hash == '#!' || location.hash == '') && window.innerWidth >= 768) {
		const mainnavEntrySubnavLiElements = document.querySelectorAll('.mainnav--entry--subnav li');

		[...mainnavEntrySubnavLiElements].forEach((element) => {
			element.style.opacity = '0';
			element.style.transform = 'scale(0)';
		});
		[...mainnavEntrySubnavLiElements].forEach((element, index) => {
			setTimeout(() => {
				element.style.opacity = null;
				element.style.transform = null;
			}, index * 50 + 1000);
		});
	}
}());
